/**
 * Shared utility functions for ui-components package.
 * Provides cn() for Tailwind class merging using clsx and tailwind-merge.
 */
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
/**
 * Merge Tailwind CSS classes with clsx and tailwind-merge.
 * Used by shadcn/ui components for conditional class merging.
 * @param inputs - class values to merge
 */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
//# sourceMappingURL=utils.js.map